
import Button from '../../../components/base/Button';

export default function AdvocacyHeroSection() {
  return (
    <section 
      className="relative py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.8)), url('https://public.readdy.ai/ai/img_res/79750c1859a0d57e28357967c04a3693.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Advocacy & Policy
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto">
            Leading healthcare policy development and professional advancement for pharmacists and veterinarians across Canada
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12 max-w-4xl mx-auto">
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-2">25+</div>
              <div className="text-lg">Active Campaigns</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-2">18</div>
              <div className="text-lg">Legislative Wins</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-2">13</div>
              <div className="text-lg">Provinces & Territories</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-2">5,000+</div>
              <div className="text-lg">Advocacy Members</div>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button className="bg-white text-blue-900 hover:bg-gray-100 px-8 py-3 text-lg font-medium whitespace-nowrap">
              Join Our Advocacy Network
            </Button>
            <Button className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-3 text-lg font-medium whitespace-nowrap">
              View Current Campaigns
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
